<template>
  <div class="messengerService">
    <h1>{{ $t("groups.title") }}</h1>
    <div class="row">
      <div class="col-md-12 text-right">
        <Json2Csv :json-data="csvData" :csv-title="`Messenger_Service_Data`">
          <button class="btn-download">{{ $t("events.listEvents.donwloadBtn") }}</button>
        </Json2Csv>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="messengerTable"
          id="messengerTable"
          class="mt-5"
        >
          <template #createdAt="props">
            <p>{{props.row.reportDateFormat}}</p>
          </template>
          <template #image="props">
            <div v-if="props.row.image === '' " class="gray">
              <span>No Image</span>
            </div>
            <img v-else class="image-group" :src="props.row.image" />
          </template>
          <template #details="props">
            <router-link
              class="icon-black"
              :to="{
            name: 'Group Detail',
            params: { id: props.row.chatId}
          }"
            >
              <i class="far fa-eye"></i>
            </router-link>
          </template>
        </v-server-table>
      </div>
    </div>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/messengerService";
const api = new API_SERVICE();
import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();
import Json2Csv from "vue-json-to-csv";
import moment from "moment";
export default {
  components: {
    Json2Csv,
  },
  data() {
    return {
      downloadData: [],
      csvData: null,
      dictionary: {
        chatName: this.$t("groups.table.headings.chatName"),
        reportDateFormat: this.$t("groups.table.headings.createdAt"),
        numberMembers: this.$t("groups.table.headings.numberMembers"),
        image: this.$t("groups.table.headings.image"),
      },
    };
  },
  async beforeMount() {
    await this.downloadTable();
  },
  methods: {
    async downloadTable() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let data = {
          all: true,
        };
        const resp = await api.downloadGroupsTable(data);
        for (let index = 0; index < resp.data.length; index++) {
          let formatDate = moment(resp.data[index].createdAt).format(
            "DD/MM/YY, HH:mm a"
          );
          if (resp.data[index].image) {
            const signedUrl = s3.getSignedUrl(resp.data[index].image);
            resp.data[index].image = signedUrl;
          } else {
            resp.data[index].image = "";
          }

          resp.data[index].reportDateFormat = formatDate;
        }
        this.downloadData = resp.data;

        this.itemsToDownload();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    itemsToDownload: function () {
      const itemsFields = [
        "chatName",
        "reportDateFormat",
        "numberMembers",
        "image",
      ];
      let downloadArray = this.downloadData.map((item) => {
        let obj = {};
        itemsFields.forEach((field) => {
          obj[this._translateHeader(field)] = item[field];
        });

        return obj;
      });
      this.csvData = downloadArray;
    },
    _translateHeader(header) {
      if (this.dictionary.hasOwnProperty(header)) {
        return this.dictionary[header];
      }
      return header;
    },
  },
  computed: {
    appLang: function () {
      return this.$store.getters["settings/currentLang"];
    },
    userTable: function () {
      return this.$refs.messengerTable;
    },
    table_columns: function () {
      return ["chatName", "createdAt", "numberMembers", "image", "details"];
    },
    table_headings: function () {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach((column) => {
          headings[column] = this.$t(`groups.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function () {
      return this.table_columns.filter(
        (column) =>
          column !== "details" &&
          column !== "createdAt" &&
          column !== "image" &&
          column !== "numberMembers"
      );
    },
    table_options: function () {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: false,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: ["chatName", "createdAt", "numberMembers"],

          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort",
          },
          resizableColumns: false,
          perPage: 10,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
          },

          requestAdapter: function (data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.orderBy = data.orderBy ? data.orderBy : "chatName";
            queries.orderType = data.ascending ? "ASC" : "DESC";
            return queries;
          },
          requestFunction: async function (data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              const resp = await api.getGroups(data);

              for (let index = 0; index < resp.data.length; index++) {
                let formatDate = moment(resp.data[index].createdAt).format(
                  "DD/MM/YY, HH:mm a"
                );
                if (resp.data[index].image) {
                  const signedUrl = s3.getSignedUrl(resp.data[index].image);
                  resp.data[index].image = signedUrl;
                } else {
                  resp.data[index].image = "";
                }

                resp.data[index].reportDateFormat = formatDate;
              }
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function (response) {
            return {
              data: response.data,
              count: +response.total,
            };
          },
        },
      };
    },
  },
};
</script>

<style>
.gray {
  background-color: #cccccc;
  height: 100px;
  width: 150px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pull-right > button {
  background-color: transparent !important;
  border-radius: 0px;
  border: 1px solid #000;
  margin-bottom: 1rem;
}
.table td {
  vertical-align: middle;
}
.table {
  text-align: center !important;
  justify-content: center;
}
.messengerService tbody td {
  text-align: center !important;
}
.messengerService thead th {
  text-align: center !important;
}
#VueTables_th--reportDate {
  width: 250px !important;
}
#VueTables_th--status {
  width: 150px !important;
}
.icon-black {
  color: #000;
}
.icon-black:hover {
  color: black;
  text-decoration: none;
}
.btn-download {
  padding: 0.7rem 2rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.image-group {
  width: 150px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
</style>